import {
  BlogCard,
  BlogError,
  BlogTags,
  BottomGraphic,
  FadeIn,
  Footer,
  GradientBg,
  Header,
  Pagination,
} from "../../components"
import Subscribe from "../../components/CustomerIOSubscribe"
import { api } from "../../ghostClient"
import {
  Pagination as GhostPagination,
  PostOrPage,
  Tag,
} from "@tryghost/content-api"
import { GetStaticProps } from "next"
import { NextSeo } from "next-seo"
import { useRouter } from "next/router"
import React from "react"

interface Props {
  posts: PostOrPage[]
  pagination: GhostPagination
  tags: Tag[]
  hasError?: boolean
}
export default function Blog({ posts, pagination, tags, hasError }: Props) {
  const router = useRouter()
  const canonicalUrl = (
    `https://www.coverdash.com` + (router.asPath === "/" ? "" : router.asPath)
  ).split("?")[0]

  // const [posts, setPosts] = React.useState<PostOrPage[]>([]);
  // const [pagination, setPagination] = React.useState<GhostPagination>();
  // const [tags, setTags] = React.useState<Tag[]>([]);
  // const [hasError, setHasError] = React.useState(false);

  // React.useEffect(() => {
  //   try {
  //     api.posts
  //       .browse({
  //         formats: ['html', 'plaintext'],
  //         // page: Number(1),
  //         limit: 9,
  //         include: 'tags',
  //         fields: [
  //           'id',
  //           'title',
  //           'slug',
  //           'excerpt',
  //           'published_at',
  //           'feature_image',
  //           'reading_time'
  //         ]
  //       })
  //       .then(posts => {
  //         // console.log('posts:', posts);
  //         setPosts(posts);
  //         setPagination(posts?.meta.pagination);
  //       });

  //     api.tags.browse().then(tags => {
  //       // console.log('tags:', tags);
  //       setTags(tags);
  //     });
  //   } catch (error) {
  //     setHasError(true);
  //   }
  // }, []);
  return (
    <>
      <NextSeo
        title="Blog"
        description="Insurance insights, SMB guides, and explainers from Coverdash. Practical articles for startups and growing businesses—read the latest on our blog. — Coverdash"
        canonical={canonicalUrl}
        openGraph={{
          url: canonicalUrl,
          title: "Blog",
          description:
            "Insurance insights, SMB guides, and explainers from Coverdash. Practical articles for startups and growing businesses—read the latest on our blog. — Coverdash",
        }}
      />
      <div className="overflow-hidden">
        <GradientBg />
        <Header />

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-24">
          <div className="text-center">
            <FadeIn>
              <h1 className="text-4xl tracking-tight font-extrabold text-alt sm:text-5xl md:text-6xl">
                Blog
              </h1>
            </FadeIn>
            <FadeIn>
              <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
                Welcome to the Coverdash insurance blog. Here you&rsquo;ll find
                valuable articles tailored to your business needs, so you can be
                ready in a dash for whatever comes next.
              </p>
            </FadeIn>

            <FadeIn>
              <div className="w-full max-w-md mx-auto mt-6 mb-10">
                <Subscribe />
              </div>
            </FadeIn>

            {hasError ? (
              <BlogError />
            ) : (
              <div className="mt-6 md:flex md:justify-between md:items-end text-left">
                <BlogTags tags={tags} />
              </div>
            )}
          </div>
        </div>

        <div className="mx-auto max-w-7xl grid gap-5 lg:grid-cols-3 sm:grid-cols-2 px-4 sm:px-6 lg:px-8 mt-8 mb-12">
          {/* {posts
            ? posts.map(post => <BlogCard key={post.id} post={post} />)
            : [1, 2, 3].map(i => (
                <div
                  key={i}
                  className="flex flex-col rounded-lg shadow-lg overflow-hidden"
                >
                  <div className="flex-shrink-0">
                    <div className="h-48 w-full object-cover bg-gray-100 animate-pulse" />
                  </div>
                  <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                    <div className="flex-1 gap-1">
                      <div className="h-10 rounded bg-gray-100 animate-pulse" />
                      <div className="mt-6 h-4 rounded bg-gray-100 animate-pulse" />
                      <div className="mt-2 h-4 rounded bg-gray-100 animate-pulse" />
                    </div>
                    <div className="mt-6 flex items-center">
                      <div className="flex space-x-1 text-sm text-gray-500">
                        <div className="h-4 w-20 rounded bg-gray-100 animate-pulse" />
                      </div>
                    </div>
                  </div>
                </div>
              ))} */}
          {posts.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>

        <div className="mx-auto max-w-7xl mt-12 mb-20">
          {pagination && <Pagination pagination={pagination} />}
        </div>
      </div>

      <BottomGraphic />
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  try {
    const posts = await api.posts.browse({
      formats: ["html", "plaintext"],
      // page: Number(1),
      limit: 9,
      include: "tags",
      fields: [
        "id",
        "title",
        "slug",
        "excerpt",
        "published_at",
        "feature_image",
        "reading_time",
      ],
    })

    const tags = await api.tags.browse()

    return {
      props: {
        posts,
        pagination: posts?.meta.pagination,
        tags,
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 10, // In seconds
    }
  } catch (error) {
    return {
      props: {
        hasError: true,
      },
    }
  }
}
